import { render, staticRenderFns } from "./addFBoy.vue?vue&type=template&id=15b04472&scoped=true"
import script from "./addFBoy.vue?vue&type=script&lang=js"
export * from "./addFBoy.vue?vue&type=script&lang=js"
import style0 from "./addFBoy.vue?vue&type=style&index=0&id=15b04472&prod&scoped=true&lang=css"
import style1 from "./addFBoy.vue?vue&type=style&index=1&id=15b04472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b04472",
  null
  
)

export default component.exports